import {
  DEFAULT_DATETIME_SECONDS_FORMAT,
  formatDateTimeFromTimestamp,
  parsePricingLogTag
} from "../../../utils"
import { PricingLog } from "../../../../types"

type Props = {
  value: PricingLog
  className?: string
}

const PricingProfileCell = ({ value, className }: Props) => (
  <td className={`${className} px-3 py-4 text-sm`}>
    <div className="flex flex-col">
      <div className="pb-1 whitespace-nowrap text-gray-500 md:hidden">
        {formatDateTimeFromTimestamp(
          value.timestamp,
          DEFAULT_DATETIME_SECONDS_FORMAT
        )}
      </div>
      <div className="whitespace-nowrap">
        {value?.ob_profile_name || parsePricingLogTag(value.tag)}
      </div>
    </div>
  </td>
)

export default PricingProfileCell
